export default function capitalFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
